// Event-driven transition orchestrator.
// DelayLink awaits cover() before navigating; pages await reveal() before
// hiding the curtain. Sequencing comes from DragonBones COMPLETE events,
// not setTimeout guesses.
let player = null;
let pendingCover = null;
let pendingReveal = null;

const cover = () => {
    if (!player) return Promise.resolve();
    if (!pendingCover) {
        pendingCover = player.cover().then(() => {
            pendingCover = null;
        });
    }
    return pendingCover;
};

const reveal = () => {
    if (!player) return Promise.resolve();
    if (!pendingReveal) {
        pendingReveal = player.reveal().then(() => {
            pendingReveal = null;
        });
    }
    return pendingReveal;
};

const setPlayer = (p) => {
    player = p;
};

export default {cover, reveal, setPlayer};



// WEBPACK FOOTER //
// ./src/transitionController.js